import { IntegrationShortcodes } from '~/mixins/integrationsDetailMixin'

export const descriptionMap: Record<IntegrationShortcodes, string> = {
  [IntegrationShortcodes.SLACK]: 'Send event alerts to your Slack channel',
  [IntegrationShortcodes.JIRA]: 'Create issues from DeepSource to Jira',
  [IntegrationShortcodes.VANTA]: 'Send code vulnerability data to Vanta'
}
